import { useTranslation } from 'react-i18next'

const StudyOverview = () => {
  const { t } = useTranslation()

  return <div>{t('ETMF_STATUS_TITLE')}</div>
}

export default StudyOverview
